import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import classnames from 'classnames';
import Button from '@/components/Button';
import Collapse from '@/components/Collapse';
import Pills from '@/components/Pills';
import Icon from '@/components/Icon';
import NavLink from '@/components/NavLink';
import Tabs from '@/components/Tabs';
import Tooltip from '@/components/Tooltip';
import {
  settingsAutomationTemplatesPath,
  settingsAutomationsPath,
  settingsIntegrationsPath,
  settingsSettingsPath,
  settingsCurrentPlanPath,
  settingsCurrentPlanForbiddenPath,
  settingsFunnelsPath
} from '@/routes';
import { useAuth } from '@/lib/auth';

function SettingsBase() {
  const menuClassName = 'fw-bold text-dark-gray';

  const { user } = useAuth();
  const canSeePlansTab = user.privileges.account_admin;

  const accountPaths = canSeePlansTab
    ? settingsCurrentPlanPath()
    : settingsCurrentPlanForbiddenPath();

  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className='d-flex h-100'>
      <div className='d-flex h-100'>
        <Pills
          style={collapsed ? { width: '4.4rem' } : { width: '14rem' }}
          className={classnames(
            'nav-settings-pills',
            'd-flex',
            'flex-column',
            'bg-light',
            'py-4 px-2',
            { 'px-4': !collapsed }
          )}
        >
          <Tabs className='d-flex flex-column w-100'>
            <Pills.Item>
              <Tooltip content='Minha conta' hide={!collapsed}>
                <NavLink
                  className={menuClassName}
                  href={accountPaths}
                  end
                >
                  <Icon name='card-pay' className={collapsed ? '' : 'mb-1'} />
                  <Collapse in={!collapsed} dimension='width'>
                    <span
                      className={classnames(
                        'h4 width-4 text-nowrap ms-2',
                        { 'd-none': collapsed }
                      )}
                    >
                      Minha conta
                    </span>
                  </Collapse>
                </NavLink>
              </Tooltip>
            </Pills.Item>

            <Pills.Item>
              <Tooltip content='Automações' hide={!collapsed}>
                <NavLink
                  className={menuClassName}
                  href={settingsAutomationTemplatesPath()}
                  active={window.location.pathname.includes(settingsAutomationsPath())}
                >
                  <Icon name='lightning' className={collapsed ? '' : 'mb-1'} />
                  <Collapse in={!collapsed} dimension='width'>
                    <span
                      className={classnames(
                        'h4 width-4 text-nowrap ms-2',
                        { 'd-none': collapsed }
                      )}
                    >
                      Automações
                    </span>
                  </Collapse>
                </NavLink>
              </Tooltip>
            </Pills.Item>

            <Pills.Item>
              <Tooltip content='Integrações' hide={!collapsed}>
                <NavLink
                  className={menuClassName}
                  href={settingsIntegrationsPath()}
                >
                  <Icon name='integration' className={collapsed ? '' : 'mb-1'} />
                  <Collapse in={!collapsed} dimension='width'>
                    <span
                      className={classnames(
                        'h4 width-4 text-nowrap ms-2',
                        { 'd-none': collapsed }
                      )}
                    >
                      Integrações
                    </span>
                  </Collapse>
                </NavLink>
              </Tooltip>
            </Pills.Item>

            <Pills.Item>
              <Tooltip content='Configurações' hide={!collapsed}>
                <NavLink
                  className={menuClassName}
                  href={settingsFunnelsPath()}
                  active={window.location.pathname.includes(settingsSettingsPath())}
                >
                  <Icon name='config' className={collapsed ? '' : 'mb-1'} />
                  <Collapse in={!collapsed} dimension='width'>
                    <span
                      className={classnames(
                        'h4 width-4 text-nowrap ms-2',
                        { 'd-none': collapsed }
                      )}
                    >
                      Configurações
                    </span>
                  </Collapse>
                </NavLink>
              </Tooltip>
            </Pills.Item>
          </Tabs>

          <div className={classnames(
            'd-flex mt-auto w-100',
            { 'justify-content-end': !collapsed },
            { 'justify-content-center': collapsed }
          )}>
            <Button
              variant='white'
              onClick={() => setCollapsed((prev) => !prev)}
            >
              {
                collapsed
                  ? <Icon name='double-arrow-right' />
                  : <Icon name='double-arrow-left' />
              }
            </Button>
          </div>
        </Pills>
      </div>

      <Outlet />
    </div>
  );
}

export default SettingsBase;
